@if (showNavbar) {
  <nav
    class="navbar navbar-expand-xl fixed-top px-0 px-md-3 px-sm-0 d-flex"
    [class.navbar--scrolled]="isScrolled"
  >
    <div class="container-fluid">
      <app-logo-box [scrollThreshold]="logoScrollThreshold" />
      <app-menu
        [showExtraPages]="true"
        [menuClassName]="'me-auto'"
        class="navbar-collapse collapse d-contents justify-content-end align-items-center"
      />
      <ul class="nav flex-row align-items-center list-unstyled gap-2 gap-md-3">
        <vertical-menu-button></vertical-menu-button>
        @if (authShellVisible$ | async) {
          <app-notification-dropdown class="ms-1 ms-md-3"></app-notification-dropdown>
        }
        <app-quick-actions-bar class="d-none d-md-flex mb-1"></app-quick-actions-bar>
      </ul>
    </div>
  </nav>
}
<div class="page-content">
  <router-outlet></router-outlet>
</div>
<router-outlet name="modal"></router-outlet>

@if (showNavbar) {
  <app-footer></app-footer>
  <app-support-widget></app-support-widget>
}